<template>
    <div class="d-flex flex-column align-items-center">
      <content-header-custom
        title="FAQs"
        class="w-100 mxw-md px-10"
        includeBack
        :subTitle="subTitle"
      >
      </content-header-custom>
      <content-body-card class="w-100">
        <section class="preview pt-1"
          v-for="(faq, fIndex) in filteredFaqs"
          :key="fIndex"
          :ref="faq.primary.title[0] ? faq.primary.title[0].text : faq.id"
          >
            <Collapsible class="content" :open="false" :title="faq.primary.title[0] ? faq.primary.title[0].text : faq.id" :ref="faq.primary.title[0] ? faq.primary.title[0].text : faq.id" >
              <div class="content" slot="body">
                <h2 class="document-title" v-if="faq.primary.title[0]">
                  {{ faq.primary.title[0].text }}
                </h2>
                <div v-for="(item, index) in faq.items"  :key="index" :ref="item.title[0] ? item.title[0].text : ''" >
                  <div slot="body">
                    <template>
                      <!-- <h3 class="document-title" :title="item.title[0] ? item.title[0].text : ''">{{ item.title[0] ? item.title[0].text : '' }}</h3> -->
                      <div v-for="(child, cIndex) in item" :key="`child-${cIndex}`">
                        <PrismicRichText :field="child" fallback="<p>No content</p>" class="prismic-richtext" v-if="child && !child.link_type" />
                        <VuePdfEmbed :source="child.url" v-if="child && child.link_type" />
                      </div>
                    </template>
                  </div>
                </div>

              </div>
            </Collapsible>
            <!-- <pdf :src="activeDocument.url" /> -->
          </section>
      </content-body-card>
    </div>
  </template>

<script>
/* eslint-disable max-len */

import _ from 'lodash';
import Collapsible from './components/Collapsible.vue';
//   import playerDetails from '@/mixins/player-details';

export default {
  name: 'Documentation',
  components: {
    Collapsible,
    //   MemberDetail: () => import('./components/MemberDetails'),
    //   RegoHistory: () => import('./components/RegoHistory'),
    //   Accreditations: () => import('./components/Accreditations'),
    //   Performances: () => import('./components/Performances'),
    //   Bookings: () => import('./components/Bookings'),
    //   Communications: () => import('./components/Communications'),
    //   PurchaseItems: () => import('./components/PurchaseItems'),
  },
  props: {
    tabName: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      activeName: this.tabName ? this.tabName : 'member-profile',
      subTitle:
          'On this screen you can find commonly asked questions regarding our registration flow and how-to walkthroughs for our platform. If you have any questions that are not answered here, please contact our support team.',
      loaded: false,
      faqs: [],
    };
  },
  async mounted() {
    await this.getDocuments();
  },
  methods: {
    async getDocuments() {
      const response = await this.$prismic.client.query(
        this.$prismic.predicate.at('document.type', 'documentation')
      );

      // this.documents = response.results.filter((doc) => doc.data && doc.data.visible);
      // this.documents = this.documents.filter((doc) => !doc.data.title[0].text || !doc.data.title[0].text.toLowerCase().includes('faq'));
      this.faqs = response.results
        .filter((doc) => doc.data && doc.data.visible)
        .filter((doc) => doc.data.title[0].text && doc.data.title[0].text.toLowerCase().includes('faq'));
      this.activeDocumentId = this.faqs.length > 0 ? this.faqs[0].id : null;
    },
  },
  computed: {
    filteredFaqs() {
      const documents = this.activeDocument?.body || [];
      return documents.filter((faq) => faq?.primary?.title[0]?.text.toLowerCase().includes('participant')) || [];
    },
    activeDocument() {
      const found = this.faqs.find((doc) => doc.id === this.activeDocumentId);
      return found && found.data
        ? {
          ...found.data,
          body: found.data.body.sort((a, b) => {
            const aTitle = _.get(a, 'primary.title[0].text', '');
            const bTitle = _.get(b, 'primary.title[0].text', '');
            return aTitle.localeCompare(bTitle);
          }).map((faq) => ({
            ...faq,
            items: faq.items.sort((a, b) => {
              const aTitle = _.get(a, 'title[0].text', '');
              const bTitle = _.get(b, 'title[0].text', '');
              return aTitle.localeCompare(bTitle);
            })
          }))
        }
        : false;
    },
  },
};
</script>

  <style scoped lang="scss">
  .el-date-editor,
  .el-select,
  .el-input {
    width: 100%;
  }

  .main-content {
    width: 100%;
  }

  .avatar-section {
    position: relative;
    display: inline-block;
    height: 70px;
    width: 70px;
    border-radius: 50%;
    overflow: hidden;
    .upload-button {
      position: absolute;
      display: inline-block;
      background-color: rgb(45, 58, 69, 0.35);
      bottom: 0;
      right: 0;
      height: 22px;
      width: 100%;
      text-align: center;
      color: white;
      font-size: 0.7em;
      line-height: 1.75em;
      font-family: $fontLight;
      cursor: pointer;
    }
  }
  </style>
